import React from "react";
import { C, R, S } from "../theme";

export function Button({ title, onPress, variant = "primary", loading, disabled, testID, icon, style }) {
  const bg = { primary: C.amber, green: C.green, red: C.red, ghost: "transparent", dark: C.card2 }[variant];
  const fg = variant === "primary" ? C.black : C.text;
  return (
    <button
      data-testid={testID}
      disabled={disabled || loading}
      onClick={onPress}
      className="pressable"
      style={{
        minHeight: 56,
        borderRadius: R.md,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: S.sm,
        padding: `0 ${S.lg}px`,
        width: "100%",
        backgroundColor: bg,
        opacity: disabled ? 0.5 : 1,
        border: variant === "ghost" ? `2px solid ${C.borderStrong}` : "none",
        color: variant === "ghost" ? C.amber : fg,
        fontSize: 17,
        fontWeight: 800,
        letterSpacing: 0.3,
        ...style,
      }}
    >
      {loading ? (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" style={{ display: "block" }} aria-label="Loading">
          <circle cx="12" cy="12" r="9" stroke={fg} strokeOpacity="0.25" strokeWidth="3" />
          <path d="M12 3 a9 9 0 0 1 9 9" stroke={fg} strokeWidth="3" strokeLinecap="round">
            <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.7s" repeatCount="indefinite" />
          </path>
        </svg>
      ) : (<>{icon}{title}</>)}
    </button>
  );
}

export function Field({ label, testID, style, multiline, ...props }) {
  const inputStyle = {
    backgroundColor: C.card2,
    borderRadius: R.md,
    border: `1px solid ${C.borderStrong}`,
    color: C.text,
    fontSize: 17,
    padding: `0 ${S.md}px`,
    minHeight: 54,
    width: "100%",
    outline: "none",
    ...(multiline ? { minHeight: 80, padding: S.md, resize: "vertical" } : {}),
    ...style,
  };
  return (
    <div style={{ marginBottom: S.md }}>
      {!!label && (
        <div style={{ color: C.sub, fontSize: 13, fontWeight: 700, marginBottom: S.xs, textTransform: "uppercase", letterSpacing: 0.5 }}>
          {label}
        </div>
      )}
      {multiline ? (
        <textarea data-testid={testID} style={inputStyle} {...props} />
      ) : (
        <input data-testid={testID} style={inputStyle} {...props} />
      )}
    </div>
  );
}
